import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate, useLocation } from 'react-router-dom';
import { StoreProvider } from './context/StoreContext';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import ProductPage from './pages/ProductDetail';
import Checkout from './pages/Checkout';
import OrderConfirmation from './pages/OrderConfirmation';
import ViewOrders from './pages/ViewOrder';
import StoreNotExistPage from './pages/comingSoon/storeNotExist';
import OrderFailure from './pages/OrderFailure';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AppWrapper from './components/Common/AppWrapper';
import ComingSoon from './pages/comingSoon';
import StoreBuilder from './pages/StoreBuilder';
import PetGroomingWebsite from './pages/StoreBuilder/PetGroomingWebsite';
import { FontWrapper } from './components/Common/FontWrapper';
import Products from './pages/Products';
import Brands from './pages/Brand';
import CartFullView from './components/CartView/CartFullView';
import BrandDetails from './pages/BrandDetails';
import Collections from './pages/Collections';
import CollectionProducts from './pages/Collections/Product';
import IframeHeader from './components/Header/IframeHeader';
import { isInIframe } from './utilities/helper';
import ErrorBoundary from './components/Common/ErrorBoundary';
// import NoMatch from './pages/NoMatch';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  const generateRandomId = (length) => {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789' + new Date().valueOf();
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
      counter += 1;
    }
    return result;
  }

  const setupPriorityEnvironment = () => {
    let src = "https://js.sandbox.prioritypassport.com/";
    if (process.env.REACT_APP_API_ENDPOINT == 'https://backend2.shopdotapp.com') {
      src = "https://js.prioritypassport.com/";
    }
    const script = document.createElement('script');
    script.src = src;
    document.body.appendChild(script);
  };

  useEffect(() => {
    setupPriorityEnvironment();
    const device_id = localStorage.getItem('device_id');
    if (!device_id) {
      const new_device_id = generateRandomId(6);
      localStorage.setItem('device_id', new_device_id);
    }
  }, []);

  return (
      <StoreProvider>

        <Router>
          <ScrollToTop />
          <div className={`${!isInIframe() ? 'min-h-screen' : ''} flex flex-col`}>
            <FontWrapper>
            
              <ToastContainer position="top-right" autoClose={5000} hideProgressBar newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
              <AppWrapper>
                <ErrorBoundary>
                {!isInIframe() ? <Header /> : <IframeHeader />}   
                <Routes>
                  {/* <Route path="/" element={<Home />} /> */}
                  <Route path="/" element={<StoreBuilder />} />
                  <Route path="/all-products" element={<Products />} />
                  <Route path="/all-brands" element={<Brands />} />
                  <Route path="/product/:productId" element={<ProductPage />} />
                  <Route path="/brands/:id" element={<BrandDetails />} />
                  <Route path="/brands/:id/vendor/:vendorId" element={<BrandDetails />} />
                  <Route path="/viewcart" element={<CartFullView />} />
                  <Route path="/checkout" element={<Checkout />} />
                  <Route path="/order-confirmation" element={<OrderConfirmation />} />
                  <Route path="/order-failure" element={<OrderFailure />} />
                  <Route path="/coming-soon" element={<ComingSoon />} />
                  <Route path="/view-order/:id" element={<ViewOrders />} />
                  <Route path="/store-not-available" element={<StoreNotExistPage />} />
                  <Route path="/all-collections" element={<Collections />} />
                  {/* Old address — links partners already saved still land on the list. */}
                  <Route path="/collections" element={<Navigate to="/all-collections" replace />} />
                  <Route path="/collections/:id" element={<CollectionProducts />} />
                  <Route path="/*" element={<Navigate to="/" replace />} />
                  {/* <Route path="/*" element={<NoMatch />} /> */}
                </Routes>
                </ErrorBoundary>

              </AppWrapper>
              {/* {!shouldHideHeaderFooter && } */}
            </FontWrapper>
          </div>
        </Router>
      </StoreProvider>
  );
}

export default App;